(ns portal.messages)

(def ui-messages
  {:delivery {:list {:pending "Loading delivery data, this may take a while."
                     :failure "Failed to load delivery data."}
              :details {:pending "Downloading delivery report, this may take a while."
                        :failure "Failed to download delivery report."
                        :success "Successfully downloaded delivery report."
                        :hint "Please select the months that you want to include in your report."}}})
